import * as React from 'react';
// eslint-disable-next-line import/no-cycle
import { ToggleLeft, ToggleRight } from '../../Icons';
import styles from './toggle-icon.module.css';

interface ToggleIconProps {
    active: boolean;
    className?: string;
    message?: string;
    toggle: (newValue: boolean) => void;
    hide?: boolean;
}

// eslint-disable-next-line import/prefer-default-export
export const ToggleIcon: React.FC<ToggleIconProps> = ({ active, className = '', message = '', toggle, hide = false }) => {
    const handleClick = React.useCallback(() => toggle(!active), [active, toggle]);

    if (hide) return null;

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div className={`${styles.ActiveToggleIcon} ${className}`} onClick={handleClick} data-qa={`toggle-icon-${message}`}>
            {active ? <ToggleRight /> : <ToggleLeft />}
            {message && <p>{message}</p>}
        </div>
    );
};
